<template>
	<view class="box" v-if="info">
		<view class="box-title">{{info.name}}</view>
		<view class="box-time">发布时间：{{info.createDate}}</view>
		<view class="box-content">
			<u-parse :content="info.content"></u-parse>
		</view>
		<view class="xian"></view>
		<view class="pl">
			<view class="pl-title">评论 {{info.commentCount || 0}}</view>
			<view class="pl-wu">
				<image src="/static/images/default_nocomment@2x.png" mode="widthFix"></image>
			</view>
			<!-- <view class="pl-item">
				<view class="pl-item-tx">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
				<view class="pl-item-info">
					<view class="pl-item-info-name">李万敏</view>
					<view class="pl-item-info-content">
						当前挖掘机技术正朝着电动化、智能化和绿色环保的方向快速发展
					</view>
					<view class="pl-item-info-list">
						<view class="pl-item-info-list-image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="pl-item-info-list-image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view style="width: 132rpx; height: 0;"></view>
						<view style="width: 132rpx; height: 0;"></view>
					</view>
					<view class="pl-item-info-data">
						<view class="pl-item-info-data-time">30分钟前</view>
						<view class="pl-item-info-data-list">
							<view class="pl-item-info-data-list-item">
								<image src="/static/icon/ic_reply2@2x.png" mode="widthFix"></image>
							</view>
							<view class="pl-item-info-data-list-item">
								<image src="/static/icon/dianzan.png" mode="widthFix"></image>
								<text>3</text>
							</view>
						</view>
					</view>
					
					<view class="pl-item" style="border: none;">
						<view class="pl-item-tx">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="pl-item-info">
							<view class="pl-item-info-name">李万敏</view>
							<view class="pl-item-info-content">
								当前挖掘机技术正朝着电动化、智能化和绿色环保的方向快速发展
							</view>
							<view class="pl-item-info-list">
								<view class="pl-item-info-list-image">
									<image src="/static/logo.png" mode="widthFix"></image>
								</view>
								<view class="pl-item-info-list-image">
									<image src="/static/logo.png" mode="widthFix"></image>
								</view>
								<view style="width: 132rpx; height: 0;"></view>
								<view style="width: 132rpx; height: 0;"></view>
							</view>
							<view class="pl-item-info-data">
								<view class="pl-item-info-data-time">30分钟前</view>
								<view class="pl-item-info-data-list">
									<view class="pl-item-info-data-list-item">
										<image src="/static/icon/ic_reply2@2x.png" mode="widthFix"></image>
									</view>
									<view class="pl-item-info-data-list-item">
										<image src="/static/icon/dianzan.png" mode="widthFix"></image>
										<text>3</text>
									</view>
								</view>
							</view>
						</view>
					</view>
				</view>
			</view> -->
		</view>
		<view style="width: 100%; height: calc(100rpx + env(safe-area-inset-bottom));"></view>
		<view class="footer">
			<view class="footer-box">
				<input type="text" placeholder="快来说点什么吧～">
				<view class="footer-box-images">
					<image src="/static/icon/ic_like@2x.png" mode="widthFix"></image>
					<image src="/static/icon/ic_collect@2x.png" mode="widthFix"></image>
					<image src="/static/icon/ic_share@2x.png" mode="widthFix"></image>
				</view>
			</view>
			<view style="width: 100%; height: env(safe-area-inset-bottom);"></view>
		</view>
		<!-- 删除评论 -->
		<u-popup :show="show" round="5" mode="bottom">
			<view class="dele">
				<view class="dele-title">删除我的评论</view>
				<view class="dele-item" style="color: #E4001D;">删除</view>
				<view class="dele-item" @click="show = false">取消</view>
			</view>
		</u-popup>
		<!-- 发布评论 -->
		<u-popup :show="show1" round="5" mode="bottom">
			<view class="pus">
				<view class="pus-content">
					<textarea placeholder="说点什么吧～"></textarea>
					<view class="pus-content-list">
						<view class="pus-content-list-item" v-for="(item, index) in 1" :key="index">
							<view class="shanchu">
								<image src="/static/icon/ic_delete2@2x.png" mode="widthFix"></image>
							</view>
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view style="width: 100rpx; height: 0;"></view>
						<view style="width: 100rpx; height: 0;"></view>
						<view style="width: 100rpx; height: 0;"></view>
					</view>
				</view>
				<view class="pus-cz">
					<image src="/static/icon/ic_pic@2x.png" mode="widthFix"></image>
					<view class="pus-cz-btn">发送</view>
				</view>
			</view>
		</u-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				id: null,
				show: false,
				show1: false,
				info: null,
				content: ''
			}
		},
		onLoad(option) {
			this.id = option.id
			this.getDetails()
		},
		methods: {
			getDetails() {
				this.$u.api.getArticleDetail({
					id: this.id
				}).then(res => {
					if (res.code === 200) {
						console.log(res)
						this.info = res.data
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 30rpx 0;
		box-sizing: border-box;
		.pus {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			.pus-cz {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 30rpx;
				image {
					width: 48rpx;
					height: 48rpx;
				}
				.pus-cz-btn {
					width: 124rpx;
					height: 72rpx;
					line-height: 72rpx;
					text-align: center;
					background: #004096;
					border-radius: 40rpx;
					font-weight: 400;
					font-size: 30rpx;
					color: #FFFFFF;
				}
			}
			.pus-content {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #F3F3F3;
				border-radius: 16rpx;
				textarea {
					width: 100%;
					height: 100rpx;
					font-weight: 400;
					font-size: 30rpx;
					color: #111111;
				}
				.pus-content-list {
					width: 100%;
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					justify-content: space-between;
					margin-top: 30rpx;
					.pus-content-list-item {
						width: 100rpx;
						height: 100rpx;
						border-radius: 8rpx;
						overflow: hidden;
						position: relative;
						margin-bottom: 7rpx;
						.shanchu {
							position: absolute;
							top: 0;
							right: 0;
							width: 32rpx;
							height: 32rpx;
							z-index: 99;
							image {
								width: 100%;
							}
						}
						image {
							width: 100%;
						}
					}
				}
			}
		}
		.dele {
			width: 100%;
			.dele-title {
				width: 100%;
				height: 114rpx;
				line-height: 114rpx;
				text-align: center;
				font-weight: 400;
				font-size: 28rpx;
				color: #777777;
			}
			.dele-item {
				width: 100%;
				height: 102rpx;
				line-height: 102rpx;
				text-align: center;
				font-weight: 400;
				font-size: 32rpx;
				color: #333333;
				border-top: 1rpx solid #E5E5E5;
			}
		}
		.footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			z-index: 999;
			background-color: #ffffff;
			height: calc(100rpx + env(safe-area-inset-bottom));
			.footer-box {
				width: 100%;
				height: 100rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				box-shadow: 0rpx -1rpx 0rpx 0rpx #EEEEEE;
				input {
					flex: 1;
					padding: 0 30rpx;
					box-sizing: border-box;
					height: 64rpx;
					background: #F7F7F7;
					border-radius: 32rpx;
					border: 1rpx solid #E5E5E5;
					font-weight: 400;
					font-size: 26rpx;
					color: #111111;
				}
				.footer-box-images {
					flex-shrink: 0;
					margin-left: 40rpx;
					image {
						width: 48rpx;
						height: 48rpx;
						margin-right: 30rpx;
						&:last-child {
							margin: 0 !important;
						}
					}
				}
			}
		}
		.pl {
			width: 100%;
			margin-top: 20rpx;
			padding: 0 30rpx;
			box-sizing: border-box;
			.pl-title {
				width: 100%;
				font-weight: 500;
				font-size: 32rpx;
				color: #111111;
				margin-bottom: 30rpx;
			}
			.pl-wu {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				image {
					width: 356rpx;
					height: 356rpx;
					margin-top: 50rpx;
				}
			}
			.pl-item {
				width: 100%;
				padding: 24rpx 0;
				box-sizing: border-box;
				border-bottom: 1rpx solid #E5E5E5;
				display: flex;
				align-items: flex-start;
				.pl-item-tx {
					flex-shrink: 0;
					margin-right: 24rpx;
					width: 68rpx;
					height: 68rpx;
					border-radius: 50%;
					overflow: hidden;
					image {
						width: 100%;
					}
				}
				.pl-item-info {
					flex: 1;
					display: flex;
					flex-direction: column;
					.pl-item-info-name {
						font-weight: 400;
						font-size: 28rpx;
						color: #777777;
					}
					.pl-item-info-content {
						font-weight: 400;
						font-size: 28rpx;
						color: #333333;
						margin-top: 16rpx;
					}
					.pl-item-info-list {
						width: 100%;
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						justify-content: space-between;
						margin-top: 20rpx;
						.pl-item-info-list-image {
							width: 132rpx;
							height: 132rpx;
							border-radius: 16rpx;
							overflow: hidden;
							image {
								width: 100%;
							}
						}
					}
					.pl-item-info-data {
						width: 100%;
						margin-top: 24rpx;
						display: flex;
						align-items: center;
						justify-content: space-between;
						.pl-item-info-data-time {
							font-weight: 400;
							font-size: 24rpx;
							color: #999999;
						}
						.pl-item-info-data-list {
							display: flex;
							align-items: center;
							.pl-item-info-data-list-item {
								margin-left: 30rpx;
								display: flex;
								align-items: center;
								image {
									width: 28rpx;
									height: 28rpx;
								}
								text {
									font-weight: 400;
									font-size: 24rpx;
									color: #AAAAAA;
									margin-left: 8rpx;
								}
							}
						}
					}
				}
			}
		}
		.box-title {
			padding: 0 30rpx;
			box-sizing: border-box;
			font-weight: 500;
			font-size: 44rpx;
			color: #222222;
		}
		.box-time {
			padding: 0 30rpx;
			box-sizing: border-box;
			font-weight: 400;
			font-size: 26rpx;
			color: #999999;
			margin-top: 20rpx;
		}
		.xian {
			width: 100%;
			height: 20rpx;
			background-color: #F9F9FB;
		}
		.box-content {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			margin-top: 36rpx;
			background-color: #ffffff;
		}
	}
</style>